/**
 * Marque : un tracé sinueux reliant un point de départ à un point d'arrivée.
 *
 * L'itinéraire plutôt que l'avion ou la valise — c'est ce que produit
 * l'application, et le motif reste lisible réduit à seize pixels, ce qui n'est
 * pas le cas d'un dessin plus figuratif.
 */
export function Logo({ taille = 30, titre }) {
  return (
    <svg
      className="logo"
      width={taille}
      height={taille}
      viewBox="0 0 32 32"
      role={titre ? 'img' : undefined}
      aria-label={titre}
      aria-hidden={titre ? undefined : 'true'}
      focusable="false"
    >
      <defs>
        <linearGradient id="logo-fond" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#7cb3de" />
          <stop offset="100%" stopColor="#2e6d9c" />
        </linearGradient>
      </defs>
      <rect width="32" height="32" rx="9" fill="url(#logo-fond)" />
      <path
        d="M9.5 22.5 C 12.5 15.5, 19 20.5, 22.5 9.5"
        fill="none"
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeDasharray="0.1 4.2"
        opacity="0.95"
      />
      <circle cx="9.5" cy="22.5" r="3.1" fill="#fff" />
      <circle cx="22.5" cy="9.5" r="3.1" fill="#fff" />
      <circle cx="22.5" cy="9.5" r="1.3" fill="#2e6d9c" />
    </svg>
  );
}
